import { render, staticRenderFns } from "./DivisionRecordPanel.vue?vue&type=template&id=3dca9154&scoped=true"
import script from "./DivisionRecordPanel.vue?vue&type=script&lang=js"
export * from "./DivisionRecordPanel.vue?vue&type=script&lang=js"
import style0 from "./DivisionRecordPanel.vue?vue&type=style&index=0&id=3dca9154&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca9154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dca9154')) {
      api.createRecord('3dca9154', component.options)
    } else {
      api.reload('3dca9154', component.options)
    }
    module.hot.accept("./DivisionRecordPanel.vue?vue&type=template&id=3dca9154&scoped=true", function () {
      api.rerender('3dca9154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/DivisionRecordPanel.vue"
export default component.exports